<template>
  <div v-if="transaction && !isLoading">
    <div class="box box-default">
      <div class="box-header">
        <div class="flex align-items-center justify-between">
          <h3 class="box-title">{{ transaction.Prefix === 'T' ? 'Transaction' : 'Payout' }} Detail</h3>
          <div v-if="transaction.Prefix === 'T'" class="flex align-items-center">
            <a :href="'https://cointopay.com/invoice/' + transaction.Security"
               class="mr-8" target="_blank">Invoice Public Url</a>
            <a v-tooltip="{content: 'Invoice Public URL', trigger: 'click hover focus'}"
               class="nav-action" style="color: #007bff;" @click="copyInvoiceURL(transaction.Security)">
              <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                  stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="box-body" style="padding: 0 15px">
        <div class="row">
          <div class="col-md-2">Merchant ID</div>
          <div class="col-md-10">
            <router-link :to="{ name: 'user-detail', params: { id: transaction.MerchantID }}" tag="a">
              {{ transaction.MerchantID }}
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Confirm Code</div>
          <div class="col-md-10">
            <div class="input-group" style="max-width: 300px;">
              <input aria-label="" style="height:29px;" type="text" readonly id="security" class="form-control" :value="transaction.Security"/>
              <div class="input-group-btn">
                <button class="btn btn-primary btn-sm" @click="copyConfirmCode()">Copy</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Merchant</div>
          <div class="col-md-10">
            <router-link :to="{ name: 'user-detail', params: { id: transaction.MerchantID }}" tag="a">
              {{ transaction.ShopTitle }}
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Username</div>
          <div class="col-md-10">
            <router-link :to="{ name: 'user-detail', params: { id: transaction.MerchantID }}" tag="a">
              {{ transaction.OwnerNickName }}
            </router-link>
          </div>
        </div>
        <div v-if="transaction.RegisteredEmail" class="row">
          <div class="col-md-2">Registered Email</div>
          <div class="col-md-10">{{ transaction.RegisteredEmail + '@' + transaction.XChangeServer }}</div>
        </div>
        <div v-if="isAuthorized('admin-commander') && !isSecureCloud && transaction.XChangeID !== 0" class="row">
          <div class="col-md-2">XChangeID</div>
          <div class="col-md-10">
            <router-link
              :to="{ name: 'coin-health-detail', params: { id: transaction.AltCoinID }, query: { q: 'xChange', id: transaction.XChangeID } }"
              tag="a">
              {{ 'X' + transaction.XChangeID }}
            </router-link>
          </div>
        </div>
        <div v-if="transaction.Prefix === 'T'" class="row">
          <div class="col-md-2">Initial Amount</div>
          <div class="col-md-10">
            {{ transaction.InitialAmount + ' ' + transaction.LongName }}
            <span class="ml-8">
              <i class="fa fa-copy pointer" @click="toConverter(toFixed(transaction.InitialAmount), transaction.AltCoinID)"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Amount</div>
          <div class="col-md-10">
            <router-link tag="a" :to="{name: 'coin-health-detail', params: { id: transaction.AltCoinID }}">
              {{ transaction.Amount + ' ' + transaction.LongName }}
              <img :src="generateIconUrl(transaction.CoinName)" alt="" class="ml-8 w-20"/>
            </router-link>
            <span class="ml-8">
              <i class="fa fa-copy pointer" @click="toConverter(toFixed(transaction.Amount), transaction.AltCoinID)"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Original Amount</div>
          <div class="col-md-10">
            {{ transaction.OriginalAmount + ' ' + transaction.InputCurrency }}
            <span class="ml-8">
              <i class="fa fa-copy pointer" @click="toConverter(toFixed(transaction.OriginalAmount), shortNameToID(transaction.InputCurrency))"></i>
            </span>
          </div>
        </div>
        <div v-if="transaction.NotEnough === 1 && transaction.Status.toLowerCase() === 'underpaid'" class="row">
          <div class="col-md-2">Missing Amount</div>
          <div class="col-md-10 flex align-items-center">
            {{ transaction.MissingAmount + ' ' + transaction.LongName }}
            <a v-if="!transaction.MissingAmountSecurity" class="ml-8" @click="generateTransaction()">
              <span v-if="loader !== 'generateTransaction'">
                Generate Transaction of Missing amount: {{ transaction.MissingAmount + ' ' + transaction.LongName }}
              </span>
              <i v-if="loader === 'generateTransaction'" class="fa fa-circle-o-notch fa-spin"></i>
            </a>
            <div v-if="transaction.MissingAmountSecurity" class="ml-8 flex align-items-center">
              <span>Missing amount invoice</span>
              <a
                v-tooltip="{content: 'Invoice Public URL', trigger: 'click hover focus'}"
                class="nav-action ml-8" @click="copyInvoiceURL(transaction.MissingAmountSecurity)">
                <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                    stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div v-if="transaction.MinerFee" class="row">
          <div class="col-md-2">Miner Fee</div>
          <div class="col-md-10">
            {{ transaction.MinerFee + ' ' + transaction.LongName }}
            <span class="ml-8">
              <i class="fa fa-copy pointer" @click="toConverter(toFixed(transaction.MinerFee), transaction.AltCoinID)"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Transaction ID</div>
          <div class="col-md-10">{{ transaction.TransactionID }}</div>
        </div>
        <div v-if="transaction.MasterTransactionID && transaction.MasterTransactionID !== transaction.TransactionID"
             class="row">
          <div class="col-md-2">Master Transaction ID</div>
          <div class="col-md-10">
            <router-link
              :to="{name: 'transaction-detail', params: { id: formatMasterID(transaction.MasterTransactionID) } }"
              tag="a">
              {{ transaction.MasterTransactionID }}
            </router-link>
          </div>
        </div>
        <div v-if="transaction.SubTransactions"
             class="row">
          <div class="col-md-2">Sub Transactions</div>
          <div class="col-md-10">
            <template v-for="(id, index) in subTransactions">
              <label :key="index" class="label label-default mr-4">
                <router-link :to="{name: 'transaction-detail', params: { id: formatMasterID(id) } }" tag="a">
                  {{ id }}
                </router-link>
              </label>
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Type</div>
          <div class="col-md-10">
            {{
              transaction.ExternalTransactionProvider ? transaction.ExternalTransactionProvider : transaction.TransactionType
            }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Status</div>
          <div class="col-md-10">
            <span v-if="transaction.Prefix === 'P'"
                  v-html="fs(transaction.Status)"></span>
            <span v-if="transaction.Prefix !== 'P'" @click="launchTransactionStatusModal()"
                  v-html="fs(transaction.Status)"></span>
          </div>
        </div>
        <div class="row" v-if="transaction.Prefix === 'T'">
          <div class="col-md-2">Exchange ID</div>
          <div class="col-md-10">
            <span @click="showExchangeDetail(transaction.ExchangeID)" class="pointer">
              {{ transaction.ExchangeID }}
            </span>
          </div>
        </div>
        <div class="row" v-if="transaction.ExpiredDate">
          <div class="col-md-2">Expiry Date</div>
          <div class="col-md-10">{{ transaction.ExpiredDate }}</div>
        </div>
        <div class="row">
          <div class="col-md-2">Customer Reference</div>
          <div class="col-md-10">
            {{ transaction.CustomerReferenceNr }}
            <span class="ml-8">
              <i class="fa fa-clipboard pointer" @click="copyToClipboard(transaction.CustomerReferenceNr)"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">Comments</div>
          <div class="col-md-10 col-lg-6">
            <button class="btn btn-primary btn-sm btn-flat mb-8" @click="launchUpdateTransactionLogsModal(transaction)">
              Update Comments
            </button>
            <div class="textarea" v-html="transactionComments"></div>
          </div>
        </div>
        <div v-if="transaction.Prefix === 'T'" class="row">
          <div class="col-md-2">Refund Address</div>
          <div class="col-md-10">
            <span v-if="!isEditableRefundAddress" class="pointer" @click="isEditableRefundAddress = true">
              {{ transaction.RefundAddress ? transaction.RefundAddress : 'NA' }}
            </span>
            <div v-if="isEditableRefundAddress" class="row">
              <div class="col-md-4">
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(updateRefundAddress)">
                    <div class="flex">
                      <ValidationProvider v-slot="{ errors }" name="refund address" rules="" tag="div">
                        <input v-model="formRefundAddress.RefundAddress" aria-label="" class="form-control"
                               placeholder="Refund address / (crypto or coin address)" type="text"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <button class="btn btn-primary btn-flat btn-square ml-8" type="submit">
                        <svg v-if="loader !== 'updateRefundAddress'" class="w-24 h-24" fill="none" stroke="currentColor"
                             viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="2"></path>
                        </svg>
                        <i v-if="loader === 'updateRefundAddress'" class="fa fa-circle-o-notch fa-spin"></i>
                      </button>
                      <button class="btn btn-square btn-danger btn-flat ml-8" type="button"
                              @click="isEditableRefundAddress = false">
                        <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="2"></path>
                        </svg>
                      </button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isCoinAddress" class="row">
          <div class="col-md-2">Coin Address</div>
          <div class="col-md-10">
            <a v-if="transaction.BlockExplorer"
               :href="transaction.BlockExplorer + decodeURIComponent(transaction.CoinAddress)"
               target="_blank">{{ decodeURIComponent(transaction.CoinAddress) }}</a>
            <span v-if="!transaction.BlockExplorer">{{ transaction.CoinAddress }}</span>
          </div>
        </div>
        <div v-if="transaction.Tag" class="row">
          <div class="col-md-2">Memo/Tag</div>
          <div class="col-md-10">{{ transaction.Tag }}</div>
        </div>
        <div v-if="transaction.InvoiceCC" class="row">
          <div class="col-md-2">Invoice CC</div>
          <div class="col-md-10">{{ transaction.InvoiceCC }}</div>
        </div>
        <div v-if="transaction.Prefix === 'T'" class="row">
          <div class="col-md-2">Reopenable</div>
          <div class="col-md-10">
            <div class="d-inline-block mr-8" v-html="fs(transaction.Reopenable)"></div>
            <div v-if="transaction.Reopenable && transaction.Status.toLowerCase() !== 'waiting'"
                 class="d-inline-block mr-8">
              <a class="pointer" @click="reOpenTransaction()">
                Re-open transaction
                <span v-if="loader === 'reopen'" class="ml-8">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
              </a>
            </div>
            <div v-if="transaction.Status.toLowerCase() !== 'waiting' && isAuthorized('admin-commander')"
                 class="d-inline-block">
              <a class="pointer" @click="reOpenAdminMode()">
                Re-open Admin Mode
                <span v-if="loader === 'reopen-admin-mode'" class="ml-8">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div v-if="transaction.ConfirmURL" class="row">
          <div class="col-md-2">Confirm URL</div>
          <div class="col-md-10">{{ transaction.ConfirmURL }}</div>
        </div>
        <div v-if="transaction.FailURL" class="row">
          <div class="col-md-2">Failure URL</div>
          <div class="col-md-10">{{ transaction.FailURL }}</div>
        </div>
        <div v-if="transaction.CustomerIP" class="row">
          <div class="col-md-2">Customer</div>
          <div class="col-md-10">{{ transaction.CustomerIP + ' - ' + transaction.CustomerCountry }}</div>
        </div>
        <div v-if="transaction.EndCustomerIP" class="row">
          <div class="col-md-2">End Customer</div>
          <div class="col-md-10">{{ transaction.EndCustomerIP + ' - ' + transaction.EndCustomerCountry }}</div>
        </div>
        <div class="row">
          <div class="col-md-2">Created On</div>
          <div class="col-md-10">{{ fd(transaction.CreatedOn) }}</div>
        </div>
        <div v-if="transaction.Confirmed && transaction.TransactionConfirmedOn" class="row">
          <div class="col-md-2">Confirmed On</div>
          <div class="col-md-10">{{ fd(transaction.TransactionConfirmedOn) }}</div>
        </div>
        <div v-if="transaction.Confirmed === -1" class="row">
          <div class="col-md-2">Expired On</div>
          <div class="col-md-10">{{ fd(transaction.ExpiredDate) }}</div>
        </div>
        <div v-if="isOrderStatusUpdateAvailable" class="row">
          <div class="col-md-2">Order Status</div>
          <div class="col-md-10">
            <span v-if="!isEditableCartStatus" class="pointer"
                  @click="isEditableCartStatus = true">{{ cartStatus(transaction.CartStatusID) }}
            </span>
            <div v-if="isEditableCartStatus" class="row">
              <div class="col-md-4">
                <div class="flex justify-between">
                  <select v-model="formCartStatus.CartStatusID" aria-label="" class="form-control">
                    <option v-for="(status, index) in cartStatusList" :key="index" :value="status.id">
                      {{ status.value }}
                    </option>
                  </select>
                  <button class="btn btn-primary btn-flat btn-square ml-8" type="button"
                          @click="updateCartStatus()">
                    <svg v-if="loader !== 'updateCart'" class="w-24 h-24" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                    </svg>
                    <i v-if="loader === 'updateCart'" class="fa fa-circle-o-notch fa-spin"></i>
                  </button>
                  <button class="btn btn-square btn-danger btn-flat ml-8" type="button"
                          @click="isEditableCartStatus = false">
                    <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="transaction.Prefix === 'P' && transaction.TransactionType.toLowerCase() !== 'payout cancelled'">
          <div class="row">
            <div class="col-sm-12 text-bold">Payout Information -- {{ isPayoutType(transaction) }}</div>
          </div>
          <template v-if="isPayoutType(transaction) === 'Bank'">
            <div v-if="transaction.PayoutName" class="row">
              <div class="col-md-2">Account Holder Name</div>
              <div class="col-md-2">{{ transaction.PayoutName }}</div>
            </div>
            <div v-if="transaction.PayoutIBAN" class="row">
              <div class="col-md-2">IBAN/Account Number</div>
              <div class="col-md-10">{{ transaction.PayoutIBAN }}</div>
            </div>
            <div v-if="transaction.AccountType" class="row">
              <div class="col-md-2">Account Type</div>
              <div class="col-md-10">{{ transaction.AccountType.toLowerCase() }}</div>
            </div>
            <div v-if="transaction.TaxId" class="row">
              <div class="col-md-2">Tax Id: CUIL / CUIT</div>
              <div class="col-md-10">{{ transaction.TaxId }}</div>
            </div>
            <div v-if="transaction.BsbCode" class="row">
              <div class="col-md-2">BSC Code</div>
              <div class="col-md-10">{{ transaction.BsbCode }}</div>
            </div>
            <div v-if="transaction.PayoutBIC" class="row">
              <div class="col-md-2">BIC/Swift/Routing code</div>
              <div class="col-md-10">{{ transaction.PayoutBIC }}</div>
            </div>
            <div v-if="transaction.BranchCode" class="row">
              <div class="col-md-2">Branch Code</div>
              <div class="col-md-10">{{ transaction.BranchCode }}</div>
            </div>
            <div v-if="transaction.CPF" class="row">
              <div class="col-md-2">Recipient tax ID/CPF</div>
              <div class="col-md-10">{{ transaction.CPF }}</div>
            </div>
            <div v-if="transaction.PhoneNumber" class="row">
              <div class="col-md-2">Account Number</div>
              <div class="col-md-10">{{ transaction.PhoneNumber }}</div>
            </div>
            <div v-if="transaction.InstitutionNumber" class="row">
              <div class="col-md-2">Institution Number</div>
              <div class="col-md-10">{{ transaction.InstitutionNumber }}</div>
            </div>
            <div v-if="transaction.TransitCode" class="row">
              <div class="col-md-2">Transit Number</div>
              <div class="col-md-10">{{ transaction.TransitCode }}</div>
            </div>
            <div v-if="transaction.RUT" class="row">
              <div class="col-md-2">Beneficiary's RUT number (Rol Único Tributario)</div>
              <div class="col-md-10">{{ transaction.RUT }}</div>
            </div>
            <div v-if="transaction.CardNumber" class="row">
              <div class="col-md-2">UnionPay card number</div>
              <div class="col-md-10">{{ transaction.CardNumber }}</div>
            </div>
            <div v-if="transaction.SortCode" class="row">
              <div class="col-md-2">Sort Code</div>
              <div class="col-md-10">{{ transaction.SortCode }}</div>
            </div>
            <div v-if="transaction.IfscCode" class="row">
              <div class="col-md-2">IFSC Code</div>
              <div class="col-md-10">{{ transaction.IfscCode }}</div>
            </div>
            <div v-if="transaction.Clabe" class="row">
              <div class="col-md-2">Recipient CLABE Number</div>
              <div class="col-md-10">{{ transaction.Clabe }}</div>
            </div>
            <div v-if="transaction.SwiftCode" class="row">
              <div class="col-md-2">Swift Code</div>
              <div class="col-md-10">{{ transaction.SwiftCode }}</div>
            </div>
            <div v-if="transaction.IdDocumentType" class="row">
              <div class="col-md-2">ID Document Type</div>
              <div class="col-md-10">{{ transaction.IdDocumentType }}</div>
            </div>
            <div v-if="transaction.IdDocumentNumber" class="row">
              <div class="col-md-2">Identification Number</div>
              <div class="col-md-10">{{ transaction.IdDocumentNumber }}</div>
            </div>
            <div v-if="transaction.Abartn" class="row">
              <div class="col-md-2">Routing Number</div>
              <div class="col-md-10">{{ transaction.Abartn }}</div>
            </div>
            <div v-if="transaction.FirstLine" class="row">
              <div class="col-md-2">Address</div>
              <div class="col-md-10">{{ transaction.FirstLine }}</div>
            </div>
            <div v-if="transaction.City" class="row">
              <div class="col-md-2">City</div>
              <div class="col-md-10">{{ transaction.City }}</div>
            </div>
            <div v-if="transaction.State" class="row">
              <div class="col-md-2">State</div>
              <div class="col-md-10">{{ transaction.State }}</div>
            </div>
            <div v-if="transaction.PostCode" class="row">
              <div class="col-md-2">Postal Code</div>
              <div class="col-md-10">{{ transaction.PostCode }}</div>
            </div>
            <div v-if="transaction.Country" class="row">
              <div class="col-md-2">Country</div>
              <div class="col-md-10">{{ transaction.Country }}</div>
            </div>
          </template>
          <template v-if="isPayoutType(transaction) === 'Payeer'">
            <div v-if="transaction.PayoutTo" class="row">
              <div class="col-md-2">Payeer</div>
              <div class="col-md-10">{{ transaction.PayoutTo }}</div>
            </div>
          </template>
          <template v-if="isPayoutType(transaction) === 'PayPal'">
            <div v-if="transaction.PayoutTo" class="row">
              <div class="col-md-2">PayPal</div>
              <div class="col-md-10">{{ transaction.PayoutTo }}</div>
            </div>
          </template>
          <template v-if="isPayoutType(transaction) === 'Crypto'">
            <div class="row">
              <div class="col-md-2">Crypto Currency</div>
              <div class="col-md-10">{{ transaction.CoinName + ' - ' + transaction.LongName }}</div>
            </div>
            <div class="row">
              <div class="col-md-2">Address</div>
              <div class="col-md-10">{{ transaction.CoinAddress }}</div>
            </div>
          </template>
        </template>
        <div class="row">
          <div class="col-md-12">
            <h3 class="sub-title" style="margin-top: 0">Forward Invoice</h3>
          </div>
          <div class="col-md-5">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(forwardInvoice)">
                <ValidationProvider v-slot="{ errors }" class="form-group" name="email"
                                    rules="required|email" tag="div">
                  <label for="email">Email Address</label>
                  <div class="input-group">
                    <input id="email" v-model="formForwardInvoice.email" class="form-control" type="text"/>
                    <div class="input-group-btn">
                      <button :disabled="loader === 'forwardInvoice'" class="btn btn-primary btn-flat" type="submit">
                        Forward Invoice
                        <i v-if="loader === 'forwardInvoice'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
                      </button>
                    </div>
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </form>
            </ValidationObserver>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h3 class="sub-title" style="margin-top: 0">{{ transaction.Prefix === 'T' ? 'Transaction' : 'Payout' }}
              Actions</h3>
          </div>
          <div class="col-md-12">
            <div v-if="transaction.Prefix === 'T'">
              <button class="btn btn-primary btn-flat" @click="reportTransaction('reportTransaction')">
                Report Transaction
                <i v-if="loader === 'reportTransaction'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
              </button>
              <button class="btn btn-primary btn-flat ml-8" @click="sendMail()">
                Send Mail
                <i v-if="loader === 'sendMail'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
              </button>
              <button class="btn btn-primary btn-flat ml-8" @click="confirmationLink()">
                Confirmation Link
                <i v-if="loader === 'confirmationLink'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
              </button>
              <button class="btn btn-primary btn-flat ml-8"
                      @click="launchTransactionStatusModal()">Update Transaction Status
              </button>
              <button :disabled="!isRefundable" class="btn btn-primary btn-flat ml-8"
                      @click="refund()">
                Refund
              </button>
            </div>
            <div v-if="transaction.Prefix === 'P'">
              <button class="btn btn-primary btn-flat" @click="reportTransaction('reportPayout')">
                Report Payout
                <i v-if="loader === 'reportPayout'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
              </button>
              <button class="btn btn-primary btn-flat ml-8" @click="reversePayout()">
                Reverse Payout
                <i v-if="loader === 'reversePayout'" class="fa fa-circle-o-notch fa-spin ml-8"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Update transaction status modal -->
    <update-transaction-status-modal></update-transaction-status-modal>
    <!-- Update transaction logs modal -->
    <update-transaction-logs-modal></update-transaction-logs-modal>
    <!-- Exchange Detail Modal -->
    <exchange-detail-modal></exchange-detail-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { START_LOADING, STOP_LOADING, SAVE_CONVERTER, SET_EXTERNAL_PAYMENT_PROVIDERS, SET_PAYOUT_TYPES } from '@/store/keys'
import { formatDate, formatStatus, isAuthorized, generateIconUrl, logout, saveNotification, toFixed } from '@/lib/utils'
import UpdateTransactionStatusModal from '@/components/modals/UpdateTransactionStatusModal.vue'
import UpdateTransactionLogsModal from '../components/modals/UpdateTransactionLogsModal.vue'
import ExchangeDetailModal from '../components/modals/ExchangeDetailModal'

export default {
  name: 'TransactionDetail',
  components: {
    ExchangeDetailModal,
    UpdateTransactionLogsModal,
    UpdateTransactionStatusModal
  },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_ADMIN_API_URL,
      transaction: null,
      formForwardInvoice: {
        email: ''
      },
      formRefundAddress: {
        RefundAddress: ''
      },
      formCartStatus: {
        CartStatusID: ''
      },
      isEditableCartStatus: false,
      isEditableRefundAddress: false,
      loader: ''
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'currentUser',
      'jwtToken',
      'cartStatusList',
      'converter',
      'altCoins',
      'externalPaymentProviders',
      'payoutTypes'
    ]),
    isCoinAddress() {
      return this.transaction.CoinAddress && this.transaction.CoinAddress !== 'NA' &&
        this.transaction.CoinAddress !== 'none'
    },
    isOrderStatusUpdateAvailable() {
      return this.transaction && this.transaction.Prefix === 'T' &&
        (this.transaction.Status === 'paid' || this.transaction.Status === 'underpaid') &&
        this.transaction.Buy === 0
    },
    subTransactions() {
      if (this.transaction.SubTransactions) {
        return this.transaction.SubTransactions.split(',').filter(Boolean)
      }
      return []
    },
    isSecureCloud() {
      const type = this.transaction.ExternalTransactionProvider
        ? this.transaction.ExternalTransactionProvider : this.transaction.TransactionType
      return type === 'SecureCloud'
    },
    transactionComments() {
      return this.transaction.Comments ? this.transaction.Comments.replace(/\n/g, '<br/>') : 'NA'
    },
    isRefundable() {
      return (
        this.transaction && this.transaction.Prefix === 'T' && this.transaction.RefundAddress &&
        (this.transaction.Status === 'paid' || this.transaction.Status === 'underpaid')
      )
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.getTransaction(to.params.id)
      }
    }
  },
  methods: {
    toFixed(val) {
      return toFixed(val)
    },
    toConverter(amount, altCoinID) {
      const form = { ...this.converter }
      form.source = amount
      form.sourceAltCoinId = altCoinID
      this.$store.commit(SAVE_CONVERTER, form)
      this.copyToClipboard(amount)
    },
    copyToClipboard(val) {
      const self = this
      navigator.clipboard.writeText(val).then(function() {
        self.$toast.fire('', 'Copied to clipboard: ' + val, 'success')
        saveNotification('Copied to clipboard: ' + val)
      }, function(err) {
        console.error('Async: Could not copy text: ', err)
      })
    },
    shortNameToID(shortName) {
      const coin = this._.find(this.altCoins, { ShortName: shortName })
      return coin ? coin.ID : 625
    },
    fs(status) {
      return formatStatus(status)
    },
    fd(val) {
      return formatDate(val)
    },
    formatMasterID(id) {
      return 'T' + id.toString().padStart(9, '0')
    },
    generateIconUrl(name) {
      return generateIconUrl(name)
    },
    isAuthorized(permission) {
      return isAuthorized(permission)
    },
    isPayoutType(payout) {
      const bank = [2, 5, 10, 12, 16]
      let type = 'Crypto'
      const payoutType = Number.parseInt(payout.TransactionTypeID)
      if (payoutType === 11) {
        type = 'PayPal'
      } else if (payoutType === 17) {
        type = 'Payeer'
      } else if (bank.indexOf(payoutType) !== -1) {
        type = 'Bank'
      }
      return type
    },
    getTransaction(id) {
      this.$store.commit(START_LOADING)
      this.$http.get(`${this.apiBaseUrl}/?Call=TransactionDetail`, {
        params: {
          ID: id
        },
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        }
      }).then(response => {
        this.$store.commit(STOP_LOADING)
        if (response.status === 200) {
          this.transaction = response.data.data
          if (this.transaction.Prefix === 'T') {
            this.formCartStatus.CartStatusID = this.transaction.CartStatusID
            this.formRefundAddress.RefundAddress = this.transaction.RefundAddress
          }
        }
      }).catch(error => {
        this.$store.commit(STOP_LOADING)
        if (error && error.data && error.data.message) {
          this.$toast.fire('', error.data.message, 'error')
          saveNotification(error.data.message)
        }
      })
    },
    copyInvoiceURL(security) {
      const el = document.createElement('textarea')
      el.value = 'https://cointopay.com/invoice/' + security
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
        document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.$toast.fire('', 'Copied!', 'success')
    },
    copyConfirmCode() {
      const el = document.getElementById('security')
      const selected =
        document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.$toast.fire('', 'Copied!', 'success')
    },
    generateTransaction() {
      this.loader = 'generateTransaction'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        Checkout: true,
        MerchantID: this.transaction.MerchantID,
        SecurityCode: this.transaction.SecurityCode,
        CustomerReferenceNr: this.transaction.CustomerReferenceNr,
        AltCoinID: this.transaction.AltCoinID,
        inputCurrency: this.transaction.ShortName,
        Amount: this.transaction.MissingAmount,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/MerchantAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        const transaction = response.data
        if (transaction) {
          this.transaction.MissingAmountSecurity = transaction.Security
          this.$toast.fire('', 'Transaction created successfully', 'success')
          saveNotification('Transaction created successfully')
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    forwardInvoice() {
      this.loader = 'forwardInvoice'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/InvoiceForwarder`, {
        params: {
          invoiceAddress: this.formForwardInvoice.email,
          target: false,
          shop: this.transaction.ShopTitle,
          TransactionID: this.transaction.TransactionID,
          coinAddress: this.transaction.CoinAddress,
          qrcode: this.transaction.CoinName.toLowerCase() + ':' + this.transaction.CoinAddress,
          amount: this.transaction.Amount,
          output: 'json'
        }
      }).then(response => {
        this.loader = ''
        if (response.data.toLowerCase() === 'mail sent') {
          this.resetFormForwardInvoice()
          this.$toast.fire('', 'Invoice sent successfully', 'success')
          saveNotification('Invoice sent successfully')
        }
      }).catch(error => {
        this.loader = ''
        // Display toast error
        console.log(error)
      })
    },
    resetFormForwardInvoice() {
      this.formForwardInvoice.email = ''
      this.$nextTick(() => this.$refs.observer.reset())
    },
    reOpenTransaction() {
      this.loader = 'reopen'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: {
          Call: 'Reopen',
          MerchantID: this.transaction.MerchantID,
          APIKey: this.transaction.APIKey,
          ConfirmCode: this.transaction.Security,
          output: 'json'
        }
      }).then(response => {
        this.loader = ''
        if (response.data.status_code === 200) {
          this.transaction.Status = 'waiting'
          this.$toast.fire('', 'Transaction scheduled for re-validation', 'success')
          saveNotification('Transaction scheduled for re-validation')
        } else {
          this.$toast.fire('', response.data.message, 'error')
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    reOpenAdminMode() {
      this.loader = 'reopen-admin-mode'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: {
          Call: 'ReopenAdminMode',
          MerchantID: this.transaction.MerchantID,
          APIKey: this.transaction.APIKey,
          ConfirmCode: this.transaction.Security,
          output: 'json'
        }
      }).then(response => {
        this.loader = ''
        if (response.data.status_code === 200) {
          this.transaction.Status = 'waiting'
          this.$toast.fire('', 'Transaction scheduled for re-validation', 'success')
          saveNotification('Transaction scheduled for re-validation')
        } else {
          this.$toast.fire('', response.data.message, 'error')
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    cartStatus(cartStatus) {
      return this._.find(this.cartStatusList, { id: cartStatus }).value
    },
    updateCartStatus() {
      this.loader = 'updateCart'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        Call: 'UpdateCartStatus',
        MerchantID: this.transaction.MerchantID,
        APIKey: this.transaction.APIKey,
        TransactionID: this.transaction.TransactionID,
        CartStatusID: this.formCartStatus.CartStatusID,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        if (response.status === 200) {
          this.transaction.CartStatusID = this.formCartStatus.CartStatusID
          this.$toast.fire('', response.data.message, 'success')
          saveNotification(response.data.message)
          this.isEditableCartStatus = false
        }
      }).catch(error => {
        this.loader = ''
        // TODO: toast error message
        console.log(error)
      })
    },
    updateRefundAddress() {
      this.loader = 'updateRefundAddress'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        Call: 'Refund',
        MerchantID: this.transaction.MerchantID,
        APIKey: this.transaction.APIKey,
        RefundAddress: this.formRefundAddress.RefundAddress,
        ConfirmCode: this.transaction.Security,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        if (response.data.result === 'success') {
          this.transaction.RefundAddress = this.formRefundAddress.RefundAddress
          this.$toast.fire('', 'Refund address added successfully', 'success')
          saveNotification('Refund address added successfully')
          this.isEditableRefundAddress = false
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    reportTransaction(type) {
      this.loader = type
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        FIU: '',
        Call: 'intSwitch',
        MerchantID: this.transaction.MerchantID,
        APIKey: this.transaction.APIKey,
        ConfirmCode: this.transaction.Security,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        if (response.data.status_code === 200) {
          this.$toast.fire('', response.data.message, 'success')
          saveNotification(response.data.message)
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    sendMail() {
      this.loader = 'sendMail'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        SendMail: '',
        Call: 'intSwitch',
        MerchantID: this.transaction.MerchantID,
        APIKey: this.transaction.APIKey,
        ConfirmCode: this.transaction.Security,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        if (response.data.status_code === 200) {
          this.$toast.fire('', response.data.message, 'success')
          saveNotification(response.data.message)
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    confirmationLink() {
      this.loader = 'confirmationLink'
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        ConfirmationLink: '',
        Call: 'intSwitch',
        MerchantID: this.transaction.MerchantID,
        APIKey: this.transaction.APIKey,
        ConfirmCode: this.transaction.Security,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: payload
      }).then(response => {
        this.loader = ''
        if (response.data.status_code === 200) {
          this.$toast.fire('', response.data.message, 'success')
          saveNotification(response.data.message)
        }
      }).catch(error => {
        this.loader = ''
        console.log(error)
      })
    },
    launchTransactionStatusModal() {
      this.$bus.$emit('update-transaction-status-modal', {
        title: 'Update Transaction Status',
        data: this.transaction,
        confirm: () => {
          const id = this.transaction.Prefix + this.transaction.TransactionID.toString().padStart(9, '0')
          this.getTransaction(id)
        }
      })
    },
    reversePayout() {
      this.$swal.fire({
        title: 'Reverse payout',
        text: 'Are you sure, want to reverse payout',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00a65a',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        focusCancel: true
      }).then(({ value }) => {
        if (value && value === true) {
          const apiBaseUrl = process.env.VUE_APP_API_URL
          this.$swal.fire({
            title: '',
            text: 'Please wait...',
            showConfirmButton: false,
            backdrop: true
          })
          const payload = {
            Call: 'ReversePayout',
            MerchantID: this.currentUser.ID,
            APIKey: this.currentUser.APIKey,
            targetMerchant: this.transaction.MerchantID,
            PayoutID: this.transaction.TransactionID,
            output: 'json'
          }
          this.$http.get(`${apiBaseUrl}/v2REAPI`, {
            params: payload,
            withCredentials: true
          }).then(response => {
            this.$swal.close()
            if (response.data.status_code === 200) {
              if (response.data.result.toLowerCase() === 'success') {
                this.$toast.fire('', 'Payout reverse request submitted successfully', 'success')
                saveNotification('Payout reverse request submitted successfully')
              }
            } else if (response.data.status_code === 400) {
              if (response.data.message.toLowerCase() === 'no permission') {
                logout()
              }
            }
          }).catch(error => {
            this.$swal.close()
            console.log(error)
          })
        }
      })
    },
    launchUpdateTransactionLogsModal() {
      this.$bus.$emit('update-transaction-logs-modal', {
        title: 'Update Transaction Logs',
        data: this.transaction,
        confirm: (comments, paymentProviderID) => {
          const data = (this.transaction.Prefix === 'T') ? this.externalPaymentProviders : this.payoutTypes
          const pp = this._.find(data, { ID: paymentProviderID })
          let externalPaymentProvider = this.transaction.ExternalPaymentProvider
          if (pp) {
            externalPaymentProvider = pp.Name
          }
          this.transaction = Object.assign({}, this.transaction, {
            Comments: comments,
            ExternalPaymentProvider: externalPaymentProvider
          })
        }
      })
    },
    refund() {
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const payload = {
        MerchantID: this.currentUser.ID,
        APIKey: this.currentUser.APIKey,
        AltCoinID: this.transaction.AltCoinID,
        Amount: this.transaction.Amount,
        coinAddress: this.transaction.RefundAddress,
        ChargingMethod: 'fixed-fee',
        PayoutMonth: new Date().getMonth() + 1,
        TransactionTotal: 1,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/GetSendToAddress`, {
        params: payload
      }).then(response => {
        if (response.status === 200) {
          this.$toast.fire('', response.data, 'success')
          saveNotification(response.data)
        }
      }).catch(error => {
        console.log(error.response)
      })
    },
    getPaymentProviders() {
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMisc&type=payment_providers`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        }
      }).then(response => {
        const data = response.data.data
        this.$store.commit(SET_EXTERNAL_PAYMENT_PROVIDERS, data.externalPaymentProviders)
        this.$store.commit(SET_PAYOUT_TYPES, data.payoutTypes)
      }).catch(error => {
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.response.data)
      })
    },
    showExchangeDetail(id) {
      this.$swal.fire({
        title: '',
        text: 'Please wait...',
        showConfirmButton: false,
        backdrop: true
      })
      const url = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${url}/`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        },
        params: {
          Call: 'GetExchangeDetail',
          id: id
        }
      }).then(response => {
        const data = response.data.data
        this.$swal.close()
        this.$bus.$emit('exchange-detail-modal', {
          title: 'Exchange Detail',
          data: data
        })
      }).catch(error => {
        this.$swal.close()
        if (error.data) {
          this.$toast.fire('', error.response.data.message, 'error')
        }
      })
    }
  },
  mounted() {
    const id = this.$route.params.id
    if (id) {
      this.getTransaction(id)
    }
    this.getPaymentProviders()
  },
  beforeDestroy() {
    this.$store.commit(STOP_LOADING)
  }
}
</script>

<style lang="scss" scoped>
.row {
  padding-top: 6px;
  padding-bottom: 6px;
  border-top: 1px solid #f4f4f4;

  &:nth-child(odd) {
    background-color: #f9f9f9;
  }
}
</style>
